import request from "../../util/request"
import { APP_KEY, PHP_API_URL } from "../../util/constants";
import Cookies from 'js-cookie'
export function getAliOssTokenRequest( callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('utoken', Cookies.get("userToken"));
    return request(PHP_API_URL+"/aliyun/osssts.php", {
        method: "POST",
        body: formData
    }, callback);
}

export function changeNameRequest(name, callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"update_user_name");
    formData.append('name',name);
    formData.append('username', Cookies.get('username'));

    return request(PHP_API_URL+"/index.php/User/i", {
        method: "POST",
        body: formData
    }, callback);
}
export function changeHeaderImgRequest(image_url, callback) {
    let formData = new FormData();
    formData.append("appkey",APP_KEY);
    formData.append('caozuo',"update_user_image_url");
    formData.append('image_url',image_url);
    formData.append('username', Cookies.get('username'));

    return request(PHP_API_URL+"/index.php/User/i", {
        method: "POST",
        body: formData
    }, callback);
}